import React from 'react';
import { PageContainer } from '../../layout';

export interface ListPageScaffoldProps {
  children: React.ReactNode;
}

/**
 * PageContainer estándar para pantallas de listado (capa superior).
 * Los modales/paneles pueden ir como hermanos dentro del mismo padre.
 */
const ListPageScaffold: React.FC<ListPageScaffoldProps> = ({ children }) => (
  <PageContainer variant="full-width" padding="small">
    {children}
  </PageContainer>
);

export default ListPageScaffold;
